module.exports = __webpack_public_path__ + "img/lang-17.b1ddfd6d.jpg";